import createAxiosInstance from '../../../../api';
import { useAlert } from '../../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setCategoryListAction } from '../../../../stores/actionTypes/equipmentsActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchCategoryList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listCategory', payload)
      .then((response) => {
        dispatch(setCategoryListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setCategoryListAction([]));
        showAlert('Failed get List Category', 'warning');
      });
    return data;
  };

  const handleDeleteCategory = async (payload) => {
    await axiosInstance
      .post('/deleteCategory', payload)
      .then(() => {
        showAlert('Category deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  Category', 'warning');
      });
  };

  const handleDeleteSubCategory = async (payload) => {
    await axiosInstance
      .post('/deleteSubCategory', payload)
      .then(() => {
        showAlert('SubCategory deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  SubCategory', 'warning');
      });
  };
  return {
    fetchCategoryList,
    handleDeleteCategory,
    handleDeleteSubCategory,
  };
}
